import { Check, MapPin } from "lucide-react";

const POINTS = [
  "Family-owned and operated in Hiawatha, Kansas",
  "Authorized Lennox Dealer",
  "Factory-trained, background-checked technicians",
  "Upfront pricing — no surprise fees",
  "Workmanship and equipment warranties",
];

export default function WhyUs() {
  return (
    <section id="about" data-testid="about-section" className="py-20 sm:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-xl">
              <img
                src="https://images.pexels.com/photos/6471911/pexels-photo-6471911.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900"
                alt="Koehn Cooling technician at work"
                className="w-full h-[420px] sm:h-[520px] object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-2 sm:-right-6 bg-white rounded-2xl p-5 shadow-xl border border-slate-100 max-w-[220px]">
              <div className="text-3xl font-display font-extrabold text-[#E31837]">20+</div>
              <div className="text-sm text-slate-600 leading-tight mt-1">
                Years serving NE Kansas homes &amp; businesses
              </div>
            </div>
          </div>

          <div>
            <div className="text-xs font-semibold uppercase tracking-widest text-[#E31837] mb-3">
              Why Koehn Cooling
            </div>
            <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-slate-900">
              A neighbor you can call when comfort matters most.
            </h2>
            <p className="mt-5 text-lg text-slate-600 leading-relaxed">
              We're proud to be Hiawatha's trusted HVAC partner. Every install and repair
              comes with the craftsmanship of a local team and the engineering of
              Lennox — one of the most respected names in home comfort.
            </p>

            <ul className="mt-8 space-y-3">
              {POINTS.map((p) => (
                <li key={p} className="flex items-start gap-3" data-testid={`why-${p.slice(0,18).replace(/\s/g,'-').toLowerCase()}`}>
                  <span className="mt-0.5 w-6 h-6 rounded-full bg-[#E31837] flex items-center justify-center flex-shrink-0">
                    <Check className="w-3.5 h-3.5 text-white" strokeWidth={3} />
                  </span>
                  <span className="text-slate-700 font-medium">{p}</span>
                </li>
              ))}
            </ul>

            <div className="mt-8 flex items-center gap-2 text-sm text-slate-500">
              <MapPin className="w-4 h-4 text-slate-400" />
              1913 Iowa Street, Hiawatha, KS 66434
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
